import { createContext, useState } from 'react';

import OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData from './OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData';

export const OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionStateContext = createContext();

const OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionContextProvider = ({ children }) => {
  const stateHook = useState(OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionData.INITIAL_STATE);

  return (
    <OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionStateContext.Provider>
  );
};

export default OmeMeetOrgUnitNonAthleteEntryCredentialsSelectionContextProvider;